import { Card } from "@/components/ui/card";
import { Brain, Heart, LineChart, Shield, BookOpen, Users, Star } from "lucide-react";

export const FeaturesSection = () => {
  const features = [
    {
      title: "AI-Powered DBT Chat",
      description: "24/7 emotional support with DBT-informed responses",
      icon: Brain,
      items: [
        "Personalized DBT skill recommendations",
        "Crisis support and coping strategies",
        "Guided mindfulness exercises",
        "Real-time emotional regulation support"
      ],
      color: "primary"
    },
    {
      title: "Daily Mood Tracking",
      description: "Monitor and understand your emotional patterns",
      icon: Heart,
      items: [
        "Track daily emotional states",
        "Identify patterns and triggers",
        "Set emotional wellness goals",
        "Visualize progress over time"
      ],
      color: "secondary"
    },
    {
      title: "Safety Planning",
      description: "Create and maintain your personal safety strategy",
      icon: Shield,
      items: [
        "Customizable safety plans",
        "Emergency contact management",
        "Coping strategy documentation",
        "Share plans with support network"
      ],
      color: "accent"
    },
    {
      title: "DBT Journal",
      description: "Document your DBT journey and progress",
      icon: BookOpen,
      items: [
        "Structured DBT diary cards",
        "Skills practice tracking",
        "Daily reflection prompts",
        "Progress documentation"
      ],
      color: "primary"
    },
    {
      title: "Progress Analytics",
      description: "Track your growth and achievements",
      icon: LineChart,
      items: [
        "Weekly progress summaries",
        "Skill utilization metrics",
        "Achievement tracking",
        "Personalized insights"
      ],
      color: "secondary"
    },
    {
      title: "Community Support",
      description: "Connect with others on their DBT journey",
      icon: Users,
      items: [
        "Share experiences safely",
        "Access community resources",
        "Join support groups",
        "Learn from others' journeys"
      ],
      color: "accent"
    }
  ];

  return (
    <section className="py-12 md:py-16">
      <div className="container mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-12">Comprehensive DBT Support Features</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <Card key={index} className={`
              relative p-8 rounded-lg 
              bg-${feature.color}/5 hover:bg-${feature.color}/10 
              transition-all duration-300
              backdrop-blur-lg border border-${feature.color}/20
              card-hover
            `}>
              <div className="flex items-center gap-3 mb-4">
                <feature.icon className={`h-6 w-6 text-${feature.color}`} />
                <h3 className="text-xl font-semibold">{feature.title}</h3>
              </div>
              <p className="text-foreground/80 mb-4">{feature.description}</p>
              <ul className="space-y-2 text-foreground/80">
                {feature.items.map((item, itemIndex) => (
                  <li key={itemIndex} className="flex items-start gap-2">
                    <Star className="h-4 w-4 mt-1 text-accent" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};